/*
  Recent bekeken (sections/bb-recently-viewed.liquid).
  Bewaart de laatste bekeken producten als lijst van product-URL's in
  localStorage en toont de kaarten van eerder bekeken producten (zonder het
  huidige product). Kaarten komen uit sectie bb-recently-viewed-card.
*/
const BB_RECENTLY_VIEWED_KEY = 'bb-recently-viewed';
const BB_RECENTLY_VIEWED_MAX = 12;

class BbRecentlyViewed extends HTMLElement {
  connectedCallback() {
    const current = this.dataset.productUrl;
    const stored = this.read().filter((url) => url !== current);

    if (current) {
      this.write([current, ...stored].slice(0, BB_RECENTLY_VIEWED_MAX));
    }

    const limit = parseInt(this.dataset.limit, 10) || 4;
    const urls = stored.slice(0, limit);
    if (!urls.length) {
      this.removeSection();
      return;
    }
    this.render(urls);
  }

  read() {
    try {
      const list = JSON.parse(window.localStorage.getItem(BB_RECENTLY_VIEWED_KEY) || '[]');
      return Array.isArray(list) ? list.filter((url) => typeof url === 'string' && url.startsWith('/')) : [];
    } catch (error) {
      return [];
    }
  }

  write(list) {
    try {
      window.localStorage.setItem(BB_RECENTLY_VIEWED_KEY, JSON.stringify(list));
    } catch (error) {
      /* privémodus of opslag geblokkeerd: dan geen geschiedenis */
    }
  }

  async render(urls) {
    const sectionId = this.dataset.cardSection;
    const results = await Promise.all(
      urls.map(async (url) => {
        try {
          const separator = url.includes('?') ? '&' : '?';
          const response = await fetch(`${url}${separator}section_id=${sectionId}`);
          if (!response.ok) return null;
          const html = document.createElement('div');
          html.innerHTML = await response.text();
          return html.querySelector('.grid__item');
        } catch (error) {
          return null;
        }
      })
    );

    const items = results.filter(Boolean);
    if (!items.length) {
      this.removeSection();
      return;
    }

    const list = this.querySelector('[data-recently-viewed-list]');
    items.forEach((item) => list.appendChild(item));
    this.hidden = false;
  }

  removeSection() {
    if (window.Shopify && window.Shopify.designMode) return;
    (this.closest('.shopify-section') || this).remove();
  }
}

if (!customElements.get('bb-recently-viewed')) {
  customElements.define('bb-recently-viewed', BbRecentlyViewed);
}
